"use strict";
/**
 * 获取行情数据
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTXBJTimeList = exports.getListQuoteNPList = exports.searchListQuoteQiQuanWithPage = exports.searchListQuoteWithPage = exports.searchListQuote = exports.getListQuote = exports.getListQuoteOrFS = void 0;
var lodash_1 = __importDefault(require("lodash"));
var config_1 = require("./config");
var web_1 = __importDefault(require("../../config/web"));
var delayparams_1 = require("./delayparams");
var url_1 = require("../url");
var cookie_1 = __importDefault(require("../cookie"));
var zwhd_1 = require("../../components/zwhd");
var user_1 = __importDefault(require("../user"));
var quote_api = web_1.default.getUrl('quote_api');
var ut = web_1.default.getUrl('quote_ut');
//延迟参数
var delayparams = (0, delayparams_1.getDelayparams)();
var thisuser = user_1.default.get();
/**
 * 使用代码列表或者fs字符串查询列表行情
 * @param option
 */
function getListQuoteOrFS(option) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (option.quotecode_list != undefined) {
                return [2 /*return*/, getListQuote(option.quotecode_list, option.itemlist, option.fid, option.po, option.pz)];
            }
            else if (option.fs != undefined) {
                return [2 /*return*/, searchListQuote(option.fs, option.itemlist, option.fid || '', option.pn, option.pz, option.po)];
            }
            return [2 /*return*/, []];
        });
    });
}
exports.getListQuoteOrFS = getListQuoteOrFS;
/**
 * 获取一组行情数据
 * @param quotecode_list 行情代码数组
 * @param itemlist 配置列表
 * @returns
 */
function getListQuote(quotecode_list, itemlist, fid, po, pz) {
    if (pz === void 0) { pz = 20; }
    return __awaiter(this, void 0, void 0, function () {
        var quoteback;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        url: quote_api + 'api/qt/ulist/get?fltt=1&invt=2&cb=?',
                        type: 'GET',
                        dataType: 'jsonp',
                        data: {
                            fields: ListItemFields(itemlist),
                            secids: typeof quotecode_list == 'string' ? quotecode_list : quotecode_list.join(','),
                            ut: ut,
                            fid: fid,
                            po: po,
                            pn: 1,
                            np: 1,
                            dect: 1,
                            pz: pz,
                            wbp2u: delayparams
                        }
                    })];
                case 1:
                    quoteback = _a.sent();
                    return [2 /*return*/, BackListData(quoteback, itemlist)];
            }
        });
    });
}
exports.getListQuote = getListQuote;
/**
 * 带fs过滤功能的行情列表信息
 * @param fs fs过滤字符串
 * @param itemlist 配置列表
 * @param fid 排序字符串
 * @param pn 第几页 1开始
 * @param pz 每页多少条 默认10
 * @param po 排序 1 倒叙 0 正序 默认0
 * @returns
 */
function searchListQuote(fs, itemlist, fid, pn, pz, po) {
    if (pn === void 0) { pn = 1; }
    if (pz === void 0) { pz = 10; }
    if (po === void 0) { po = 1; }
    return __awaiter(this, void 0, void 0, function () {
        var quoteback;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        url: quote_api + 'api/qt/clist/get?np=1&fltt=1&invt=2&cb=?',
                        type: 'GET',
                        dataType: 'jsonp',
                        data: {
                            fs: fs,
                            fields: ListItemFields(itemlist),
                            fid: fid,
                            pn: pn,
                            pz: pz,
                            po: po,
                            ut: ut,
                            dect: 1,
                            wbp2u: delayparams
                        }
                    })];
                case 1:
                    quoteback = _a.sent();
                    return [2 /*return*/, BackListData(quoteback, itemlist)];
            }
        });
    });
}
exports.searchListQuote = searchListQuote;
/**
 * 带fs过滤功能的行情列表信息
 * @param fs fs过滤字符串
 * @param itemlist 配置列表
 * @param fid 排序字符串
 * @param pn 第几页 1开始
 * @param pz 每页多少条 默认10
 * @param po 排序 1 倒叙 0 正序 默认0
 * @returns
 */
function searchListQuoteWithPage(fs, itemlist, fid, pn, pz, po) {
    var _a;
    if (pn === void 0) { pn = 1; }
    if (pz === void 0) { pz = 10; }
    if (po === void 0) { po = 1; }
    return __awaiter(this, void 0, void 0, function () {
        var url, quoteback;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = quote_api + 'api/qt/clist/get?np=1&fltt=1&invt=2&cb=?';
                    if ((0, zwhd_1.fingerprintValid)() && (0, url_1.getQueryParams)('env') == null) {
                        url = 'https://pushguest.eastmoney.com/' + 'api/qt/clist/get?timil=1&np=1&fltt=1&invt=2&cb=?';
                        if (cookie_1.default.get('uidal')) {
                            url = 'https://pushlogin.eastmoney.com/' + 'api/qt/clist/get?np=1&fltt=1&invt=2&cb=?';
                        }
                    }
                    return [4 /*yield*/, $.ajax({
                            url: url,
                            type: 'GET',
                            dataType: 'jsonp',
                            data: {
                                fs: fs,
                                fields: ListItemFields(itemlist),
                                fid: fid,
                                pn: pn,
                                pz: pz,
                                po: po,
                                dect: 1,
                                ut: ut,
                                wbp2u: delayparams
                            }
                        })];
                case 1:
                    quoteback = _b.sent();
                    return [2 /*return*/, {
                            result: BackListData(quoteback, itemlist),
                            count: (_a = quoteback.data) === null || _a === void 0 ? void 0 : _a.total
                        }];
            }
        });
    });
}
exports.searchListQuoteWithPage = searchListQuoteWithPage;
/**
 * 行情-期权-T型报价
 * @param secid 品种
 * @param itemlist 时间
 * @param fid
 * @param pn
 * @param pz
 * @param po
 * @returns
 */
function searchListQuoteQiQuanWithPage(secid, time, itemlist, fid, pn, pz, po) {
    var _a;
    if (pn === void 0) { pn = 1; }
    if (pz === void 0) { pz = 10; }
    if (po === void 0) { po = 1; }
    return __awaiter(this, void 0, void 0, function () {
        var quoteback;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        url: quote_api + 'api/qt/slist/get?np=1&fltt=1&invt=2&spt=9&cb=?',
                        type: 'GET',
                        dataType: 'jsonp',
                        data: {
                            secid: secid,
                            exti: time,
                            fields: ListItemFields(itemlist),
                            fid: fid,
                            pn: pn,
                            pz: pz,
                            dect: 1,
                            po: po,
                            ut: ut,
                            wbp2u: delayparams
                        }
                    })];
                case 1:
                    quoteback = _b.sent();
                    return [2 /*return*/, {
                            result: BackListData(quoteback, itemlist),
                            count: (_a = quoteback.data) === null || _a === void 0 ? void 0 : _a.total
                        }];
            }
        });
    });
}
exports.searchListQuoteQiQuanWithPage = searchListQuoteQiQuanWithPage;
/**
 * ulist.np 行情list
 * @param quotecode_list
 * @param itemlist
 * @returns
 */
function getListQuoteNPList(quotecode_list, itemlist) {
    return __awaiter(this, void 0, void 0, function () {
        var quoteback;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        url: quote_api + 'api/qt/ulist.np/get?fltt=1&invt=2&cb=?',
                        type: 'GET',
                        dataType: 'jsonp',
                        data: {
                            fields: ListItemFields(itemlist),
                            secids: typeof quotecode_list == 'string' ? quotecode_list : quotecode_list.join(','),
                            ut: ut,
                            dect: 1,
                            intv: 2,
                            wbp2u: delayparams
                        }
                    })];
                case 1:
                    quoteback = _a.sent();
                    return [2 /*return*/, BackListData(quoteback, itemlist)];
            }
        });
    });
}
exports.getListQuoteNPList = getListQuoteNPList;
/**
 * 处理行情接口返回的列表数据
 * @param data
 * @param itemlist
 * @returns
 */
function BackListData(data, itemlist) {
    var _a;
    if (!(((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.diff) instanceof Array)) {
        return [];
    }
    return data.data.diff.map(function (v) {
        // console.info('v', v)
        var onereturn = {};
        itemlist.forEach(function (i) {
            //港股延迟市场替换
            if (v.f13 == 128)
                v.f13 = 116;
            //CME合规
            if (thisuser == null && v.f13 && (v.f13 == 101 || v.f13 == 102 || v.f13 == 103)) {
                lodash_1.default.forIn(v, function (value, key) {
                    if (key != 'f12' && key != 'f13' && key != 'f14') {
                        v[key] = '-';
                    }
                });
            }
            onereturn[i] = config_1.ListItemConfig[i].value(v);
        });
        return onereturn;
    });
}
/**
 * 生成调用一组行情的fields字符串
 * @param itemlist
 * @returns
 */
function ListItemFields(itemlist) {
    var fids = [];
    itemlist.forEach(function (v) {
        fids = fids.concat(config_1.ListItemConfig[v].fid);
    });
    var fid_list = lodash_1.default.uniq(fids).filter(function (v) { return v != ''; });
    return fid_list.join(',');
}
/**
 * 获取t型报价筛选时间列表
 * @param secid
 * @returns
 */
function getTXBJTimeList(secid) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(web_1.default.getUrl('quote_api'), "api/qt/stock/get?cb=?"),
                            type: 'GET',
                            dataType: 'json',
                            data: {
                                ut: ut,
                                mspt: 1,
                                secid: secid
                            }
                        })];
                case 1:
                    data = _b.sent();
                    if ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.optionExpireInfo) {
                        return [2 /*return*/, data.data.optionExpireInfo];
                    }
                    return [2 /*return*/, []];
                case 2:
                    error_1 = _b.sent();
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getTXBJTimeList = getTXBJTimeList;
